const styles = theme => {
  return {
    root: { width: '400px', backgroundColor: '#FAFAFA' },
    dialogContent: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    },
    infoText: {
      width: '100%',
      textAlign: 'center',
      marginBottom: '15px'
    },
    messageContainer: {
      visibility: 'hidden',
      height: '15px',
      textAlign: 'center'
    },
    messageVisible: {
      visibility: 'visible'
    },
    footer: {
      display: 'flex',
      justifyContent: 'center',
      padding: '10px 0',
      '& button': {
        marginRight: '10px',
        [theme.breakpoints.down('xs')]: {
          marginTop: '10px'
        }
      },
      [theme.breakpoints.down('xs')]: {
        flexDirection: 'column',
        alignItems: 'center'
      }
    }
  };
};

export default styles;
